import styled from '@emotion/styled'
import { Link } from 'react-router-dom'
import { PrimaryButton } from '@mmsg/louie'
import RemServImage from 'RemServ/images/banner.jpg'
import MaxxiaImage from 'Maxxia/images/banner2.jpg'

export const BannerHeading = styled.h1`
  label: BannerHeading;
  font-size: ${(props) => (props.theme.brand === 'Maxxia' ? '28px' : '48px')};
  font-weight: ${(props) => (props.theme.brand === 'Maxxia' ? 700 : 600)};
  line-height: 52px;
  @media (max-width: 719px) {
    font-size: 28px;
    line-height: 40px;
  }
`

export const BannerSubheader = styled.div`
  label: BannerSubheader;
  font-weight: ${(props) =>
    props.theme.brand === 'Maxxia' ? 'normal' : 'bold'};
  margin-bottom: 20px;
  font-size: 20px;
  max-width: 660px;
`

export const ViewPDFDiv = styled.div`
  label: ViewPDFDiv;
  display: flex;
  justify-content: end;
  @media (max-width: 719px) {
    display: inline;
    justify-content: inherit;
  }
`

export const BackToCompLink = styled(Link)`
  label: BackToCompLink;
  font-size: 20px;
  color: #fff;
  font-weight: ${(props) => props.theme.font.weight.normal};
  margin-bottom: 48px;
  :hover {
    color: #fff;
  }
`

export const BannerPrimaryButton = styled(PrimaryButton)`
  label: BannerPrimaryButton;
  background: #0000 !important;
  color: #fff !important;
  border-color: #fff !important;
  min-width: 324px;
  margin-bottom: 9px;
  @media (max-width: 719px) {
    font-weight: 600 !important;
    padding: 9px 18px !important;
    min-width: 214px;
  }
`

export const BannerContainingDiv = styled.div`
  label: BannerContainingDiv;
  background-image: url(${(props) =>
    props.theme.brand === 'Maxxia' ? MaxxiaImage : RemServImage});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: right center;
  padding: 37px;
  display: flex;
  flex-direction: row;
  justify-content: center;
`

export const BannerTextDiv = styled.div`
  label: BannerTextDiv;
  display: flex;
  margin-left: 45px;
  margin-right: 45px;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  color: #fff;
  box-sizing: border-box;
  @media (max-width: 719px) {
    padding: 30px;
    margin-left: 0px;
    margin-right: 0px;
  }
`
